export const ADOBE_VISITOR_ID = 'D=mid';

export const CAJA_FLOW_TYPE_COPY = 'copy';
export const CAJA_FLOW_TYPE_CREATE = 'create';
export const CAJA_FLOW_TYPE_DRAFT = 'draft';
export const CAJA_FLOW_TYPE_EDIT = 'edit';
export const CAJA_FLOW_TYPE_REFRESH = 'refresh';
export const CAJA_FLOW_TYPE_MULTILOCATION = 'multilocation';

export const HIRER_AD_PURCHASER_FIRST_TIME = 'hirer-first-time-ad-purchaser';
export const HIRER_AD_PURCHASER_REPEAT = 'hirer-repeat-ad-purchaser';

export const HIRER_PURCHASE_TYPE_CASUAL = 'hirer-type-casual';
export const HIRER_PURCHASE_TYPE_CONTRACT = 'hirer-type-contract';

export const IS_ON_CREDIT_HOLD_IMPRESSION = 'credit-hold-message-impression';

export const REFERRER_COPY_JOB = 'copyjob';
export const REFERRER_CREATE_JOB = 'createjob';
export const REFERRER_EDIT_DRAFT = 'editdraft';

export const SITE_SECTION = 'jobs';
export const SUB_SECTION = 'edcaja';

export const TEALIUM_AD_TYPE_CLASSIC = 'Classic';
export const TEALIUM_AD_TYPE_PREMIUM = 'Premium Performance';
